
<template>
    <div class="form-group mt-2">
        <label class="form-label" for="payment_online">
            {{this.label}}
        </label>
        <div class="" v-if="draw_items.length > 0">
            <v-select
                v-model="active_org_id"
                id="organizations_list"
                class="imc_reasons"
                :reduce="item => item.id"
                label="small_title"
                :options="this.draw_items"
                :filterable="false"
            >
                <template slot="no-options">
                    Оберіть організацію
                </template>
                
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        {{ option.small_title }}
                        <div class="small">
                            <small>
                                {{option.erdp}}
                            </small>
                        </div>
                    </div>
                </template>
            </v-select>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
    name: "organization_select",
    components : {
        vSelect
    },
    data() {
        return {
            is_load: false,
            draw_items : [],
            current_item : null,
        }
    },
    
    props : {
        active_id : {
            type : Number,
            required : true
        },
        label : {
            type : String,
            required : false,
            default : " Виберiть з випадаючого списку організацію",
        }
    },
    
    created () {
        this.load_organizations();
    },
    
    methods : {
        async load_organizations() {
            await api.get('/organizations').then(({data}) => {
                this.is_load = true;
                if(data.status === "operation_success") {
                    this.draw_items = data.data;
                }
                else {
                    this.draw_items = [];
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                this.is_load = false;
            });
        },
    },
    
    computed : {
        active_org_id : {
            get() {
                if(parseInt(this.active_id) > 0) {
                    return this.active_id;
                }
                return null;
            },
            set(new_id) {
                this.$emit('on_organization_set',new_id);
            }
        },
    }
}
</script>


<style scoped>

</style>